import styled from "styled-components";
import BaseModal from "_c/Modals/base-modal";
import Paper from "_c/Paper";
import { Button } from "_c/button";

const mobileBp = "675px";
export const Modal = styled(BaseModal)`
  overflow-y: auto;
  transform: none !important;
  left: 0 !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  position: fixed !important;
  display: flex;
`;
export const Wrap = styled(Paper)`
  position: relative;
  margin: auto auto;
  width: 600px;
  @media (max-width: ${mobileBp}) {
    border-radius: 0;
    width: 100%;
    min-height: 100%;
    padding-bottom: 50px;
    padding-top: 50px;
  }
`;
export const MobileCloseButton = styled(Button)`
  display: none;
  @media(max-width: ${mobileBp}) {
    box-shadow: none;
    display: block;
    background: var(--bg-paper);
    color: var(--font-color-accent) !important;
    z-index: 3;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    border-radius: 0;
    font-size: 16px;
    height: 38px;
    && {
      margin: 0;
    }
  }
`;
export const CloseOverlay = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
`;
export const SubmitButton = styled(Button).attrs({
  greenish: true,
  small: true,
  type: "submit",
})`
  @media (max-width: ${mobileBp}) {
    position: fixed;
    bottom: 0;
    left: 0;
    font-size: 16px;
    padding: 12px;
    width: 100%;
    margin: 0 !important;
    border-radius: 0;
  }
`;
